// extracted by mini-css-extract-plugin
export default {"header":"MainMobile_header__iCL26","body":"MainMobile_body__LKZmn"};